import React from "react";
// import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
// import "react-tabs/style/react-tabs.css";

function Portfolio() {
  return (
    <section id="work" className="portfolio-mf sect-pt4 route">
      <div className="container">
        <div className="row">
          <div className="col-sm-12">
            <div className="title-box text-center">
              <h3 className="title-a">Portfolio</h3>
              <p className="subtitle-a">Here are my projects to showcase.</p>
              <div className="line-mf"></div>
            </div>
          </div>
        </div>
        {/* <Tabs>
          <TabList>
            <Tab>Work</Tab>
            <Tab>Personal</Tab>
          </TabList>

          <TabPanel> */}
        <div className="row">
        <div className="col-md-4">
            <div className="work-box">
              <a href="https://s6.imgcdn.dev/xWqE8.png" data-lightbox="gallery-vmarine">
                <div className="work-img">
                  <img src="https://s6.imgcdn.dev/xWqE8.png" alt="3dportfolio" className="img-fluid" />
                </div>
              </a>
              <div className="work-content">
                <div className="row">
                  <div className="col-sm-12 text-center">
                    <h2 className="w-title">3D Portfolio</h2>
                    <p className="w-more">
                    A website that showcase information about myself, skills, recent work, projects and certificates.
                    </p>
                    <div className="w-more">
                      <span className="w-ctegory">#react, #tailwindcss</span>
                    </div>
                  </div>
                  <div className="col text-center pt-3 pb-3 seelive">
                    <a
                      href="https://yvesmarin-portfolio.netlify.app/"
                      className="btn btn-primary"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      View Live
                    </a>
                  </div>
                </div>
              </div>
              <a
                href="https://s6.imgcdn.dev/xafTg.webp"
                data-lightbox="gallery-vmarine"
                style={{ display: "none" }}
              >
                jsx-a11y/anchor-has-content warning
              </a>
            </div>
          </div>
          <div className="col-md-4">
            <div className="work-box">
              <a href="https://s6.imgcdn.dev/xafTg.webp" data-lightbox="gallery-vmarine">
                <div className="work-img">
                  <img src="https://s6.imgcdn.dev/xafTg.webp" alt="wilmarllc" className="img-fluid" />
                </div>
              </a>
              <div className="work-content">
                <div className="row">
                  <div className="col-sm-12 text-center">
                    <h2 className="w-title">Wilmar LLC</h2>
                    <p className="w-more">
                      A web-based platform that allows users to search, and
                      choose products that provides quality tools and great
                      service.
                    </p>
                    <div className="w-more">
                      <span className="w-ctegory">#bigcommerce</span>
                    </div>
                  </div>
                  <div className="col text-center pt-3 pb-3 seelive">
                    <a
                      href="https://wilmarllc.com/"
                      className="btn btn-primary"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      View Live
                    </a>
                  </div>
                </div>
              </div>
              <a
                href="https://s6.imgcdn.dev/xafTg.webp"
                data-lightbox="gallery-vmarine"
                style={{ display: "none" }}
              >
                jsx-a11y/anchor-has-content warning
              </a>
            </div>
          </div>
          <div className="col-md-4">
            <div className="work-box">
              <a href="https://s6.imgcdn.dev/xaZ0o.webp" data-lightbox="gallery-vmarine">
                <div className="work-img">
                  <img src="https://s6.imgcdn.dev/xaZ0o.webp" alt="portfolio" className="img-fluid" />
                </div>
              </a>
              <div className="work-content">
                <div className="row">
                  <div className="col-sm-12 text-center">
                    <h2 className="w-title">Portfolio</h2>
                    <p className="w-more">
                      A website that showcase information about myself, skills,
                      recent work, projects and certificates.
                    </p>
                    <div className="w-more">
                      <span className="w-ctegory">#react, #bootstrap</span>
                    </div>
                  </div>
                  <div className="col text-center pt-3 pb-3 seelive">
                    <a
                      href="https://johnyvesmarin.netlify.app/"
                      className="btn btn-primary"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      View Live
                    </a>
                  </div>
                </div>
              </div>
              <a
                href="https://s6.imgcdn.dev/xaZ0o.webp"
                data-lightbox="gallery-vmarine"
                style={{ display: "none" }}
              >
                jsx-a11y/anchor-has-content warning
              </a>
            </div>
          </div>

          <div className="col-md-4">
            <div className="work-box">
              <a href="https://s6.imgcdn.dev/xaxxh.md.webp" data-lightbox="gallery-vmarine">
                <div className="work-img">
                  <img src="https://s6.imgcdn.dev/xaxxh.md.webp" alt="apsonline" className="img-fluid" />
                </div>
              </a>
              <div className="work-content">
                <div className="row">
                  <div className="col-sm-12 text-center">
                    <h2 className="w-title">APS</h2>
                    <p className="w-more">
                      A web-based application that allows users to buy and sell
                      financial assets such as stocks, cryptocurrencies,
                      commodities, and forex.
                    </p>
                    <div className="w-more">
                      <span className="w-ctegory">
                        #angularjs, #nodejs, #bootstrap
                      </span>
                    </div>
                  </div>
                  <div className="col text-center pt-3 pb-3 seelive">
                    <a
                      href="https://aps-site-sample.netlify.app/"
                      className="btn btn-primary"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      View Live
                    </a>
                  </div>
                </div>
              </div>
              <a
                href="https://s6.imgcdn.dev/xaxxh.md.webp"
                data-lightbox="gallery-vmarine"
                style={{ display: "none" }}
              >
                jsx-a11y/anchor-has-content warning
              </a>
            </div>
          </div>
          <div className="col-md-4">
            <div className="work-box">
              <a href="https://s6.imgcdn.dev/xavnl.md.webp" data-lightbox="gallery-aguadeluz">
                <div className="work-img">
                  <img src="https://s6.imgcdn.dev/xavnl.md.webp" alt="workboardph" className="img-fluid" />
                </div>
              </a>
              <div className="work-content">
                <div className="row">
                  <div className="col-sm-12 text-center">
                    <h2 className="w-title">Workboard.ph</h2>
                    <p className="w-more">A web-based application that helps organisations automate and manage core business processes for optimal performance.</p>
                    <div className="w-more">
                      <span className="w-ctegory">#MEAN, #bootstrap</span>{" "}
                    </div>
                  </div>

                  <div className="col text-center pt-3 pb-3 seelive">
                    <a
                      href="https://workboard.ph/"
                      className="btn btn-primary"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      View Live
                    </a>
                  </div>
                </div>
              </div>

              <a
                href="https://s6.imgcdn.dev/xavnl.md.webp"
                data-lightbox="gallery-aguadeluz"
                style={{ display: "none" }}
              >
                jsx-a11y/anchor-has-content warning
              </a>
            </div>
          </div>

          <div className="col-md-4">
            <div className="work-box">
              <a href="https://s6.imgcdn.dev/xaOCK.webp" data-lightbox="gallery-medlingos">
                <div className="work-img">
                  <img src="https://s6.imgcdn.dev/xaOCK.webp" alt="mnksoft" className="img-fluid" />
                </div>
              </a>
              <div className="work-content">
                <div className="row">
                  <div className="col-sm-12 text-center">
                    <h2 className="w-title">MnK.Soft</h2>
                    <p className="w-more">A website that was created to represent the company and provide information and access to customers, partners, clients.</p>
                    <div className="w-more">
                      <span className="w-ctegory">#MEAN, #bootstrap</span>
                    </div>
                  </div>
                  <div className="col text-center pt-3 pb-3 seelive">
                    <a
                      href="https://mnksoft.com.ph/"
                      className="btn btn-primary"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      View Live
                    </a>
                  </div>
                </div>
              </div>

              <a
                href="https://s6.imgcdn.dev/xaOCK.webp"
                data-lightbox="gallery-medlingos"
                style={{ display: "none" }}
              >
                jsx-a11y/anchor-has-content warning
              </a>
            </div>
          </div>

          <div className="col-md-4">
            <div className="work-box">
              <a href="https://s6.imgcdn.dev/xa2FV.webp" data-lightbox="gallery-mf">
                <div className="work-img">
                  <img src="https://s6.imgcdn.dev/xa2FV.webp" alt="etc23" className="img-fluid" />
                </div>
              </a>
              <div className="work-content">
                <div className="row">
                  <div className="col-sm-12 text-center">
                    <h2 className="w-title">ETC23</h2>
                    <p className="w-more">A personal website where you can watch videos about places the blogger visited, tips and information about life, etc.</p>
                    <div className="w-more">
                      <span className="w-ctegory">#wordpress</span>
                    </div>
                  </div>
                  <div className="col text-center pt-3 pb-3 seelive">
                    <a href="#work" className="btn btn-primary isDisabled">
                      View Live
                    </a>
                  </div>
                </div>
              </div>

              <a href="https://s6.imgcdn.dev/xa2FV.webp" data-lightbox="gallery-mf" style={{ display: "none" }}>
                jsx-a11y/anchor-has-content warning
              </a>
            </div>
          </div>
          <div className="col-md-4">
            <div className="work-box">
              <a
                href="https://s6.imgcdn.dev/xa93O.webp"
                data-lightbox="gallery-mf"
              >
                <div className="work-img">
                  <img
                    src="https://s6.imgcdn.dev/xa93O.webp"
                    alt="onlineclassroom"
                    className="img-fluid"
                  />
                </div>
              </a>
              <div className="work-content">
                <div className="row">
                  <div className="col-sm-12 text-center">
                    <h2 className="w-title">CE Online Classroom</h2>
                    <p className="w-more">A digital learning environment that allows teachers and students to connect online in real time.</p>
                    <div className="w-more">
                      <span className="w-ctegory">#laravel, #bootstrap</span>
                    </div>
                  </div>
                  <div className="col text-center pt-3 pb-3 seelive">
                    <a href="#work" className="btn btn-primary isDisabled">
                      View Live
                    </a>
                  </div>
                </div>
              </div>

              <a
                href="https://s6.imgcdn.dev/xa93O.webp"
                data-lightbox="gallery-mf"
                style={{ display: "none" }}
              >
                jsx-a11y/anchor-has-content warning
              </a>
            </div>
          </div>
          <div className="col-md-4">
            <div className="work-box">
              <a
                href="https://s6.imgcdn.dev/xaVwn.webp"
                data-lightbox="gallery-mf"
              >
                <div className="work-img">
                  <img
                    src="https://s6.imgcdn.dev/xaVwn.webp"
                    alt="phdaily"
                    className="img-fluid"
                  />
                </div>
              </a>
              <div className="work-content">
                <div className="row">
                  <div className="col-sm-12 text-center">
                    <h2 className="w-title">Philippine Daily</h2>
                    <p className="w-more">A web-based application that shows information from different news platforms all in one place.</p>
                    <div className="w-more">
                      <span className="w-ctegory">#symfony, #bootstrap</span>
                    </div>
                  </div>
                  <div className="col text-center pt-3 pb-3 seelive">
                    <a href="#work" className="btn btn-primary isDisabled">
                      View Live
                    </a>
                  </div>
                </div>
              </div>

              <a
                href="https://s6.imgcdn.dev/xaVwn.webp"
                data-lightbox="gallery-mf"
                style={{ display: "none" }}
              >
                jsx-a11y/anchor-has-content warning
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Portfolio;
